import localStorageConst from './localStorage'
import routes from './routes'
import fileFormat from './fileFormat'

export default {
  localStorage: localStorageConst,
  routes,
  fileFormat,
}
